import axios from 'axios';
import qs from 'qs';
import { AuthActions } from '../modules/Auth/actions/authActions';
import { AuthService } from '../modules/Auth/services/authServices';

let api = axios.create({});

api.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

api.interceptors.request.use(config => {
    try {
        let userInfo = AuthService.getUserInfo();
        let access_token = userInfo ? userInfo.access_token : null;

        let basicAuthEndpoints = [
            'auth-service',
            'refresh-token',
        ];

        let excludeBasicAuthEndpoints = [
            'auth-service/users',
            'auth-service/auth/logout',
            'auth-service/internal/user',
            'auth-service/external/users/whoami',
        ];

        let needBasicAuth = basicAuthEndpoints.some(endpoint => config.url.includes(endpoint))
            && excludeBasicAuthEndpoints.every(endpoint => !config.url.includes(endpoint));

        if (access_token || needBasicAuth) {
            config.headers['Authorization'] = needBasicAuth
                ? 'Basic d2ViLWFkbWluOjkyODEyODMzLWI2N2QtNGY3Ni1iNzY5LTdjMmUxM2U5NzljMQ=='
                : 'Bearer ' + access_token;
        }

        let serializerParams = {
            skipNulls: true,
            arrayFormat: 'repeat',
        };
        config.paramsSerializer = params =>
            qs.stringify(params, serializerParams);
    }
    catch (error) {
        return;
    }
    return config;
});

api.interceptors.response.use(
    response => response,
    (error) => {
        const code = 401;
        const timeout = 15;
        const originalRequest = error.config;
        if (error.response.status === code && !originalRequest._retry && AuthService.getUserInfo() && AuthService.getUserInfo().refresh_token) {
            if (AuthService.PROCESS_REFRESH) {
                return new Promise((resolve, reject) => {
                    const interval = window.setInterval(() => {
                        if (!AuthService.PROCESS_REFRESH) {
                            window.clearInterval(interval);
                            originalRequest.headers.Authorization = `Bearer ${AuthService.getUserInfo().access_token}`;
                            resolve(api(originalRequest));
                        }
                        reject(error);
                    }, timeout);
                });
            }
            else {
                originalRequest._retry = true;
                AuthService.PROCESS_REFRESH = true;
                try {
                    return AuthActions.token(null, null, true)
                        .then(() => {
                            originalRequest.headers.Authorization = `Bearer ${AuthService.getUserInfo().access_token}`;
                            AuthService.PROCESS_REFRESH = false;
                            return api(originalRequest);
                        })
                        .catch(() => {
                            AuthService.PROCESS_REFRESH = false;
                            AuthService.logOut();
                        });
                }
                catch (error) {
                    AuthService.PROCESS_REFRESH = false;
                    AuthService.logOut();
                }
            }
        }
        return Promise.reject(error);
    }
);

export { api };
